import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { StaticQuery, graphql } from "gatsby";

const SaganTeamPic = () => (
  <StaticQuery
    query={graphql`
      query {
        fileName: file(relativePath: { eq: "sagan-design-team-min.jpg" }) {
          childImageSharp {
            gatsbyImageData(width: 370)
          }
        }
      }
    `}
    render={(data) => {
      return (
        <GatsbyImage
          className="shadow-md border-radius mb-4"
          image={getImage(data.fileName.childImageSharp)}
          alt="Roach Home Improvement Team Photo"
        />
      );
    }}
  />
);
export default SaganTeamPic;
